
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div class=\"mt-9\">\n  {{! The avatar size must not increase until the tablet breakpoint due to logging into\n  Pocket with FxA and maybe others later: an Apple-controlled modal displays FxA in a web\n  view and we want the \"Sign in\" button to be displayed above the fold. See FXA-7425 */ }}\n  <div class=\"avatar-wrapper mx-auto h-24 w-24 tablet:h-40 tablet:w-40\"></div>\n  <div class=\"my-5 text-base break-all\" id=\"prefillEmail\">{{ email }}</div>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  